var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:_vm.getCssClass,attrs:{"icon":_vm.icon,"type":_vm.type,"width":_vm.width,"value":_vm.value}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }